import React from 'react'

import ListStyled from './styled'

const List = ({ children }) => {
  return <ListStyled className="List">{children}</ListStyled>
}

export default List
